import React from 'react';
import PropTypes from 'prop-types';
import OfferCard from './OfferCard';
import View from '../Designer/View';
import Translation from '../Base/Translation';
import Text from '../Designer/Text';

export default class TopOffers extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            offers: null,
        };
    }

    static get propTypes() {

        return {
            companyId: PropTypes.string,
        };
    }

    componentDidMount() {

        fetch(`/api/v2/catalog/products.json?companyId=${this.props.companyId}&top=1`)
            .then((response) => response.json())
            .then((response) => this.setState({ offers: response.context }));
    }

    render() {

        if (!this.state.offers || this.state.offers.length < 1)
            return null;

        return (
            <View className='bg-primary-light p-6 flex flex-wrap gap'>
                <Text className='w-full title3 text-center'><Translation tag='aggregation.top.title' /></Text>
                <View className='w-full flex gap items-stretch scrollbar-x'>
                    {/* <Slider withoutGap> */}
                    { this.state.offers.slice(0, 3).map((offer) => this.renderOffer(offer)) }
                    { this.state.offers.slice(0, 3).map((offer) => this.renderOffer(offer)) }
                    { this.state.offers.slice(0, 3).map((offer) => this.renderOffer(offer)) }
                    { this.state.offers.slice(0, 3).map((offer) => this.renderOffer(offer)) }
                    {/* </Slider> */}
                </View>
            </View>
        );
    }

    renderOffer(offer) {

        return (
            <OfferCard
                key={ offer.id }
                badge={ offer.isTop ? <Translation tag='aggregation.top-products.popular' /> : null }
                title={ offer.name }
                mainImageLink={ offer.imageUri }
                mainImageAlt={ offer.name }
                logoImageLink={ offer.company.smallLogoUri }
                logoImageAlt={ offer.company.name }
                promoText={ offer.promoText }
                buttonText={ <Translation tag='aggregation.top-products.button' /> }
                buttonLink={ offer.uri }
                hasBorder={ offer.isTop }
            />
        );

    }

}